module.exports = __webpack_public_path__ + "static/media/friendi.9cfa01e7.png";